import { ApolloClient, InMemoryCache, HttpLink } from "@apollo/client";

const marketplaceLink = new HttpLink({
  uri: `${process.env.REACT_APP_MARKETPLACE_GRAPHQL}marketplace`,
});

export const marketplaceClient = new ApolloClient({
  link: marketplaceLink,
  cache: new InMemoryCache(),
});

const tokenLink = new HttpLink({
  uri: `${process.env.REACT_APP_MARKETPLACE_GRAPHQL}token`,
});

export const tokenClient = new ApolloClient({
  link: tokenLink,
  cache: new InMemoryCache(),
});
